module.exports = __webpack_public_path__ + "img/g1.bea6be7b.jpeg";